import React, { Component } from "react";
import _ from "lodash";
import { withRouter } from "react-router-dom";
import DrawerScrubber from "./components/drawer-scrubber";
import VerticalCenter from "./components/vertical-center";
import YearsDisplay from "./components/years-display";
import Items from "./components/drawer-items-perf";
import GlobalMenuIcon from "./components/global-menu-icon";
import GlobalMapIcon from "./components/global-map-icon";
import { inverseScale } from "./scale";
import { connect } from "react-redux";
import Easing from "./util/easing";
import compareReleaseDate from "./util/compare-release-date";
import {
  startSFXForScroll,
  stopSFXForScroll,
  setSpeed,
  setMaxSpeed,
} from "./drawer-sfx";
import { monthNumber } from "./util/months";
import { processOuttakesState } from "./util/stateProcessing";
import { setCurrentTrack } from "./currentDate";
import { resetMetadata } from "./actions/metas";
import SplashScreen from "./splash-screen";

const onDelta = (delta) => {
  setSpeed(delta);
};

/* must match drawer scss */
const topBarHeight = 106;
const itemHeight = 60;

function measureWidth() {
  return inverseScale() * window.innerWidth;
}
//content area height of the drawer
function measureHeight() {
  return inverseScale() * window.innerHeight - topBarHeight;
}
function measureFullHeight() {
  return inverseScale() * window.innerHeight;
}

class TopBar extends React.Component {
  render() {
    return (
      <div className="top-bar outtakes">
        <div className="outtakes-title">OUTTAKES</div>
      </div>
    );
  }
}

class Drawer extends React.Component {
  setScroll(amt) {
    this.refs.items.setScroll(amt);
  }
  render() {
    // Filter out any duplicates, empty items, and ensure clean item list
    let items = (this.props.items || []);
    
    let filteredItems = items.filter(item => {
      // Basic validation
      if (!item || !item.id) {
        return false;
      }
      
      // Filter out spacer items
      if (item.spacer) {
        return false;
      }
      
      // Filter out concerts that might have slipped through
      if (item.album && item.album.isConcert === true) {
        return false;
      }
      
      // Filter out hidden tracks (listOnly is intentionally not filtered here — outtakes should show regardless)
      if (item.hiddenTrack === true) {
        return false;
      }
      
      return true;
    });
    
    return (
      <div className="box">
        <Items ref="items" {...this.props} items={filteredItems} />
      </div>
    );
  }
}

let pos = 100;
let pixelPos = 0;
let prevPixelPos = 0;

let scrollInterval = null;

const didStopMoving = () => {
  if (!scrollInterval) return;
  clearInterval(scrollInterval);
  scrollInterval = null;
  console.log("ENDED");
  stopSFXForScroll();
};

let stopMovingTimeout = null;
const motionIntervalLength = (25 * 0.5) | 0;
const moveEndTimeout =
  50 >= motionIntervalLength ? motionIntervalLength * 0.8 : 50;

const updateMotion = () => {
  onDelta(Math.floor(pixelPos));
  const EPS = 1.0;
  const delta = Math.abs(pixelPos - prevPixelPos);
  if (delta <= EPS) {
    console.log("DELTA = ", delta);
    let curr = pixelPos;
    if (stopMovingTimeout) clearTimeout(stopMovingTimeout);
    stopMovingTimeout = setTimeout(() => {
      stopMovingTimeout = null;
      if (Math.abs(pixelPos - curr) <= EPS) didStopMoving();
    }, moveEndTimeout);
  }
  prevPixelPos = pixelPos;
};

class OuttakesDrawerContainer extends Component {
  constructor(props) {
    super(props);

    let position = 0;

    // Parse query string for position
    if (props.location && props.location.search) {
      let re = /position=(\d+(\.\d+)?)/;
      let m = props.location.search.match(re);
      if (m) {
        position = parseFloat(m[1]);
      }
    }

    this.state = {
      position,
      width: 0,
      height: 0,
      animating: false,
      targetYear: null,
      componentWasUpdatedInRender: false,
    };

    /* if(!scrollInterval) {
     *     scrollInterval = setInterval(updateMotion, motionIntervalLength)
     * }*/

    this.updateScrollPosition = this.updateScrollPosition.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onScrub = this.onScrub.bind(this);
    this.onWindowFocus = this.onWindowFocus.bind(this);
    this.viewMore = this.viewMore.bind(this);
    this.clickYear = this.clickYear.bind(this);
    this.boundYear = this.boundYear.bind(this);
    this.startedScrubbing = this.startedScrubbing.bind(this);
    this.endedScrubbing = this.endedScrubbing.bind(this);

    this._didScroll = this._didScroll.bind(this);
    this._didScroll = _.throttle(this._didScroll, 100);
  }
  startedScrubbing() {
    console.log("started scrubbing!");
    setMaxSpeed(0);
  }
  endedScrubbing() {
    console.log("ended scrubbing!");
    setMaxSpeed(50);
  }
  shouldComponentUpdate(newprops, newstate) {
    return true;
  }
  updateScrollPosition(pct) {
    if (pct === this.state.position) return;

    /* can happen when there are not enough items
     * to fill the viewport at initial render */
    if (_.isNaN(pct)) return;
    
    // Clamp position to valid range based on content
    const { items } = this.props;
    if (items && items.length > 0) {
      const screensWorth = measureHeight() / itemHeight;
      
      // If we have fewer items than screen height, limit scroll position
      if (items.length <= screensWorth) {
        pct = 0; // Can't scroll if content fits on screen
      } else {
        pct = Math.max(0, Math.min(100, pct));
      }
    }
    
    pos = pct;
    pixelPos = this._getPixelPosition(pos);
    onDelta(pixelPos);

    this._didScroll(pct);
  }
  _didScroll(pct) {
    this.updateCurrDate(pct, this.props.items);
    this.setState({ position: pct }, this.updatePositionUrl);
  }
  updateCurrDate(pos, items) {
    const currentItem = this._getCurrentlyCenteredItem(pos, items);
    if (currentItem && currentItem.releaseDate && currentItem.releaseDate.year) {
      setCurrentTrack(currentItem);
    }
  }
  updatePositionUrl() {
    let { position } = this.state;
    this.props.history.replace(`/outtakes?position=${position}`);
  }
  onResize() {
    let width = measureWidth();
    let height = measureHeight();
    this.setState({ width, height });
  }
  onWindowFocus() {
    _.delay(this.onResize, 30);
  }
  componentDidMount() {
    window.addEventListener("resize", this.onResize, false);
    window.addEventListener("focus", this.onWindowFocus, false);
    this.onResize();
    this.onScrub(this.state.position);
  }
  componentWillMount() {
    resetMetadata();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize, false);
    window.removeEventListener("focus", this.onWindowFocus, false);
    didStopMoving();
  }
  viewMore(item) {
    let { id, isAlbum, isFilm, isPlaylist, playlistId } = item;
    // Albums should open in album modal, tracks in info card
    if (isAlbum) {
      this.props.history.push(`/album?id=${id}&cabinetMode=outtakes`);
    } else if (isPlaylist) {
      this.props.history.push(`/playlist?id=${id || playlistId}`);
    } else if (isFilm) {
      this.props.history.push(`/film?id=${id}`);
    } else {
      // Navigate to the outtake's info card
      this.props.history.push(`/info-card?track=${id}&outtakes=true`);
    }
  }
  onScrub(amt) {
    this.refs.drawer.setScroll(amt);
    this.updateScrollPosition(amt);
  }
  clickYear(year, done) {
    let position = this._positionForYear(year);
    this.setState(
      {
        animating: true,
        targetYear: year,
      },
      () => {
        this.animateTo(position, () => {
          this.setState({ animating: false, targetYear: null });
          if (done) done();
        });
      }
    );
  }
  animateTo(newPosition, done) {
    let { position } = this.state;
    let delta = newPosition - position;
    let duration = 1000;
    let fps = 30;
    let frame = 1000 / fps;
    let frameCount = duration / frame;
    let step = 1.0 / frameCount;

    let current = 0;
    let currentFrame = 0;

    let interval = setInterval(() => {
      currentFrame++;
      current += step;
      let pos = Easing.easeInOutQuad(current) * delta + position;
      this.onScrub(pos);
      if (currentFrame >= frameCount) {
        clearInterval(interval);
        this.onScrub(newPosition);
        if (done) done();
      }
    }, frame);
  }
  _positionForItemIndex(items, i, center = true) {
    if (!items || items.length === 0) return 0;
    
    //maximum position depends on page height,
    //as the index at 100% is one page's worth
    //from the end of the collection
    let screensWorth = measureHeight() / itemHeight;
    let maxScroll = Math.max(1, items.length - screensWorth);
    let itemsize = (1 / maxScroll) * 100;
    let pos = itemsize * i;

    if (center) {
      //need to center the item in the full window, not just the content area
      let fullBottomHalf = measureFullHeight() / 2;
      let topHalfScreen = (measureHeight() - fullBottomHalf) / itemHeight;

      //center by half the page height (adjusting for content area)
      pos -= topHalfScreen * itemsize;
      //center item
      pos += itemsize / 2;
    }

    return Math.max(0, Math.min(100, pos));
  }
  _positionForYear(y) {
    let { items } = this.props;
    if (!items || items.length === 0) return 0;

    let screensWorth = measureHeight() / itemHeight;

    let pct = (idx) => (idx / (items.length - 1 - screensWorth)) * 100;

    let hasSeenDate = false;
    for (let i = 0; i < items.length; i++) {
      let item = items[i];

      if (item.completionDate && !item.spacer) {
        let { year } = item.completionDate;
        year -= 1;
        if (year > y) {
          if (hasSeenDate) return pct(i);
          else return 0;
        } else if (year === y) {
          return pct(i);
        }
      }

      if (item.completionDate && !item.spacer) hasSeenDate = true;
    }
    return 100;
  }
  boundYear(year) {
    let { items } = this.props;
    if (!items || items.length === 0) return year;
    
    let years = this._getAvailableYears();
    
    if (years.length === 0) return year;
    
    let firstYear = years[0];
    let lastYear = years[years.length - 1];

    if (year < firstYear) return firstYear;
    if (year > lastYear) return lastYear;
    return year;
  }
  _getAvailableYears() {
    let { items } = this.props;
    if (!items || items.length === 0) return [];
    
    // Filter out invalid items first
    const validItems = items.filter(item => {
      return item && 
             !item.spacer && 
             item.completionDate && 
             item.completionDate.year &&
             item.id && 
             item.title &&
             !(item.album && item.album.isConcert === true);
    });
    
    // Get all unique years from valid items with completion dates
    let yearsSet = new Set();
    validItems.forEach(it => {
      if (it.completionDate && it.completionDate.year) {
        yearsSet.add(it.completionDate.year);
      }
    });
    
    // Convert to sorted array
    return Array.from(yearsSet).sort((a, b) => a - b);
  }
  _getCurrentDate(position = this.state.position, items = this.props.items) {
    if (!items || items.length === 0) {
      return { year: 2024, month: 1, day: 1 };
    }
    
    //maximum position depends on page height,
    //as the index at 100% is one page's worth
    //from the end of the collection
    let screensWorth = measureHeight() / itemHeight;
    let maxScroll = Math.max(1, items.length - screensWorth);

    let idx = (position / 100) * maxScroll;

    //don't center item
    idx = Math.floor(idx) - 1;
    //clamp to bounds
    idx = Math.min(items.length - 1, Math.max(0, idx));

    let item = items[idx];
    let dir = idx < items.length / 2 ? +1 : -1;
    let attempts = 0;
    while ((!item || !item.completionDate) && idx >= 0 && idx < items.length && attempts < items.length) {
      //move in from the edges since the padding items don't have completionDates
      idx += dir;
      item = items[idx];
      attempts++;
    }
    
    if (item && item.completionDate) {
      return item.completionDate;
    }
    
    // Fallback to first valid item with completion date
    for (let i = 0; i < items.length; i++) {
      if (items[i] && items[i].completionDate) {
        return items[i].completionDate;
      }
    }
    
    return { year: 2024, month: 1, day: 1 };
  }
  /* returns the pixel position of the item at the top of the viewport */
  _getPixelPosition(position = this.state.position, items = this.props.items) {
    if (!items || items.length === 0 || !this.state.height) return 0;
    
    //maximum position depends on page height,
    //as the index at 100% is one page's worth
    //from the end of the collection
    let screensWorth = this.state.height / itemHeight;
    let count = Math.max(1, items.length - screensWorth);

    return count * (position / 100) * itemHeight;
  }
  _getCurrentlyCenteredItem(
    position = this.state.position,
    items = this.props.items
  ) {
    if (!items || items.length === 0) {
      return null;
    }
    
    // Filter to only valid, non-spacer items
    const validItems = items.filter(item => {
      return item && 
             !item.spacer && 
             item.completionDate && 
             item.releaseDate &&
             item.id && 
             item.title &&
             !(item.album && item.album.isConcert === true);
    });
    
    if (validItems.length === 0) {
      return null;
    }
    
    //maximum position depends on page height,
    //as the index at 100% is one page's worth
    //from the end of the collection
    let screensWorth = measureHeight() / itemHeight;
    let maxScroll = Math.max(1, validItems.length - screensWorth);

    let idx = (position / 100) * maxScroll;

    // center index in viewport
    idx = Math.floor(idx + screensWorth / 2) - 1;
    // clamp to bounds
    idx = Math.min(validItems.length - 1, Math.max(0, idx));

    let item = validItems[idx];
    
    if (item && item.completionDate && item.releaseDate && !item.spacer) {
      return item;
    }
    
    // Fallback to first valid item
    return validItems[0] || null;
  }
  render() {
    let pct = this.state.position;
    let { animating, targetYear, componentWasUpdatedInRender } = this.state;
    let currentDate = this._getCurrentDate();
    let year = animating ? targetYear : (currentDate ? currentDate.year : 2024);

    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.updateItems &&
      !componentWasUpdatedInRender
    ) {
      this.setState({ componentWasUpdatedInRender: true });
    }

    return (
      <div id="drawer" className="outtakes-drawer">
        <TopBar />
        <Drawer
          ref="drawer"
          onScroll={this.updateScrollPosition}
          pct={pct}
          viewMore={this.viewMore}
          measureWidth={measureWidth}
          measureHeight={measureHeight}
          items={this.props.items}
          dispatch={this.props.dispatch}
        />
        <div className="shader-wrapper top">
          <div className="shader top"></div>
        </div>
        <VerticalCenter className="scrubber-container">
          <DrawerScrubber
            onScroll={this.onScrub}
            pct={pct}
            moveStart={this.startedScrubbing}
            moveEnd={this.endedScrubbing}
          />
        </VerticalCenter>
        <VerticalCenter className="years-container">
          <YearsDisplay
            year={year}
            boundYear={this.boundYear}
            onClick={this.clickYear}
          />
        </VerticalCenter>
        <GlobalMenuIcon />
        <GlobalMapIcon />
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  if (state.status !== "drawerLoaded") {
    return {
      loaded: false,
    };
  }
  const processedState = processOuttakesState(state);
  const { items } = processedState;

  return { loaded: true, tracks: state.tracks, items: items || [] };
};

const OuttakesDrawerWrapper = (props) => {
  if (!props.loaded)
    return (
      <div id="drawer" className="outtakes-drawer">
        <TopBar />
        <SplashScreen loadState={100} />
      </div>
    );
  return <OuttakesDrawerContainer {...props} />;
};

export default withRouter(connect(mapStateToProps)(OuttakesDrawerWrapper));
